export default "__VITE_ASSET__DXPvTwJk__"